export default "data:image/svg+xml,%3Cpath%20d%3D%22M14.67%205v14H9.33V5h5.34zm1%2014H21V5h-5.33v14zm-7.34%200V5H3v14h5.33z%22%2F%3E"